import React from "react";
import {
  FaEdit,
  FaTrash,
  FaListAlt,
  FaPlusCircle,
  FaTags,
} from "react-icons/fa";
import {
  Button,
  Container,
  Spinner,
  Alert,
  Card,
  Row,
  Col,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  useGetCategoriesQuery,
  useDeleteCategoryMutation,
} from "../slices/categoryApiSlice";

const CategoryListScreen = () => {
  const navigate = useNavigate();

  const {
    data: categories,
    isLoading,
    error,
    refetch,
  } = useGetCategoriesQuery();

  const [deleteCategory, { isLoading: loadingDelete }] =
    useDeleteCategoryMutation();

  const handleEdit = (id) => {
    navigate(`/admin/category/${id}/edit`);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await deleteCategory(id).unwrap();
        refetch();
      } catch (err) {
        alert("Failed to delete category");
      }
    }
  };

  return (
    <Container fluid className="py-4">
      <Card className="shadow-lg p-3 border-0" style={{ borderRadius: "12px" }}>
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <h2 className="fw-bold mb-2" style={{ color: "#0d6efd" }}>
            <FaListAlt className="me-2" />
            Category List
          </h2>
          <Button
            variant="success"
            className="px-4 py-2 shadow-sm"
            onClick={() => navigate("/create-category")}
          >
            <FaPlusCircle className="me-2" /> Add Category
          </Button>
        </div>

        {loadingDelete && (
          <Alert variant="warning" className="d-flex align-items-center">
            <Spinner animation="border" size="sm" className="me-2" />
            Deleting category...
          </Alert>
        )}

        {isLoading ? (
          <div className="text-center py-5">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <Alert variant="danger">
            {error?.data?.message || "Failed to fetch categories"}
          </Alert>
        ) : categories.length > 0 ? (
          <Row className="g-3">
            {categories.map((category) => (
              <Col key={category._id} xs={12} sm={6} md={4}>
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title className="fw-bold">
                      <FaTags className="me-2" />
                      {category.name}
                    </Card.Title>
                    <Card.Text>
                      <strong>Subcategories:</strong> {category.subcategories.join(", ")}
                    </Card.Text>
                    <div className="d-flex justify-content-between flex-wrap">
                      <Button
                        variant="outline-warning"
                        size="sm"
                        onClick={() => handleEdit(category._id)}
                      >
                        <FaEdit className="me-1" /> Edit
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDelete(category._id)}
                      >
                        <FaTrash className="me-1" /> Delete
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <div className="text-center py-3">No categories found.</div>
        )}
      </Card>
    </Container>
  );
};

export default CategoryListScreen;
